import { useTranslation } from 'react-i18next';

/**
 * Renders an error message for unauthorized users
 * @returns {JSX.Element} the error message component for Unauthorized user
 */
export const Unauthorized = () => {
  const { t } = useTranslation();
  return <h4>{t('messages.error.403')}</h4>;
};
